// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 00:12:33

export default {
  "id": "epic-car-stunt-race-obby",
  "slug": "epic-car-stunt-race-obby",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/ec3ec421d1994a6ebcf021747844b0ad-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/ec3ec421d1994a6ebcf021747844b0ad/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Epic Car Stunt Race Obby",
      "description": "Epic Car Stunt Race Obby is a fast-paced, acrobatic and challenging stunt racing game. In these races with hundreds of different levels, each new track creates a completely different excitement with its special design. You can play Epic Car Stunt Race Obby against AI racers or with your friend in 2 player mode. Start the endless racing excitement now!",
      "instructions": "PLAYER 1\nMovement: \"W,A,S;D\" (Arrow keys are also active in 1 Player mode.)\nNitro: \"SHIFT\"\nRespawn: \"R\"\nCamera: \"C\"\n\nPLAYER 2\nMovement: \"ARROW KEYS\"\nNitro: \"N\"\nRespawn: \"U\"\nCamera: \"L\"",
      "genres": [
        "Casual",
        "Racing & Driving"
      ],
      "tags": [
        "1player",
        "2players",
        "car",
        "obstacle",
        "roblox"
      ]
    },
    "zh-CN": {
      "title": "史诗汽车特技赛车挑战",
      "description": "Epic Car Stunt Race Obby是一款节奏快速、技巧高超且富有挑战性的特技赛车游戏。在这些包含数百个不同等级的比赛里，每条新赛道都因其独特的设计带来全新的刺激体验。你可以与AI赛车手对战或在2人模式中与朋友一起玩。现在就开始无尽的赛车激情吧！",
      "instructions": "玩家1\n移动：\"W,A,S;D\"（在单人模式下箭头键也有效）\n氮气：\"SHIFT\"\n重生：\"R\"\n摄像头：\"C\"\n\n玩家2\n移动：\"箭头键\"\n氮气：\"N\"\n重生：\"U\"\n摄像头：\"L\"",
      "genres": [
        "休闲",
        "赛车与驾驶"
      ],
      "tags": [
        "1玩家",
        "2玩家",
        "汽车",
        "障碍物",
        "Roblox"
      ]
    },
    "zh-TW": {
      "title": "驚險車技挑戰賽",
      "description": "Epic Car Stunt Race Obby 是一場快節奏、驚險刺激的特技賽車遊戲。在這些賽事中，有數百個不同的關卡，每條新的賽道都會以其獨特的設計帶來截然不同的刺激。你可以與 AI 賽車手對戰，或在雙人模式下與朋友一起玩。即刻開啟無盡的賽車樂趣吧！",
      "instructions": "玩家1\n移動: \"W,A,S;D\"（箭頭鍵在單人模式中也有效。）\n氮氣加速: \"SHIFT\"\n重生: \"R\"\n鏡頭: \"C\"\n\n玩家2\n移動: \"箭頭鍵\"\n氮氣加速: \"N\"\n重生: \"U\"\n鏡頭: \"L\"",
      "genres": [
        "休閒",
        "賽車與駕駛"
      ],
      "tags": [
        "1人玩家",
        "2人玩家",
        "車輛",
        "障礙物",
        "羅博塾"
      ]
    },
    "zh-HK": {
      "title": "驚險車神大賽Obby",
      "description": "瘋狂車神挑戰賽是一場快節奏、高難度、驚險刺激的挑戰賽車遊戲。在這些有數百個不同等級的賽事中，每條新赛道都以其獨特設計帶來全新的刺激。你可以與AI賽車手對戰，或在雙人模式下與朋友一起玩。立即開啟無盡的賽車樂趣吧！",
      "instructions": "玩家1\n移動: \"W,A,S;D\"（箭頭鍵在同1玩家模式中亦有效）\n氮氣: \"SHIFT\"\n重生: \"R\"\n鏡頭: \"C\"\n\n玩家2\n移動: \"ARROW KEYS\"\n氮氣: \"N\"\n重生: \"U\"\n鏡頭: \"L\"",
      "genres": [
        "輕鬆",
        "賽車及駕駛"
      ],
      "tags": [
        "1人玩",
        "2人玩",
        "車",
        "障礙物",
        "Roblox"
      ]
    },
    "ja": {
      "title": "エピック・カー・スタント・レース・オビー",
      "description": "Epic Car Stunt Race Obbyは、速くて技が高難易度のスタントレースゲームです。数百の異なるレベルで行われるこれらのレースでは、それぞれのトラックが特別なデザインで全く異なる興奮を作り出します。AIレーサーとの対戦や、2プレイヤーモードで友達と一緒にプレイできます。無限のレースの興奮を今すぐ始めましょう！",
      "instructions": "PLAYER 1\n移動: \"W,A,S;D\"（1人用モードでも矢印キーが有効です。）\nナイチュロ：\"SHIFT\"\nリスポーン: \"R\"\nカメラ: \"C\"\n\nPLAYER 2\n移動: \"矢印キー\"\nナイチュロ：\"N\"\nリスポーン: \"U\"\nカメラ: \"L\"",
      "genres": [
        "カジュアル",
        "レース＆ドライビング"
      ],
      "tags": [
        "1プレイヤー",
        "2プレイヤー",
        "車",
        "障害物",
        "ロブロックス"
      ]
    },
    "ko": {
      "title": "에픽 카 스타운트 레이스 오비",
      "description": "에픽 카 스타운트 레이스 오비는 빠른 템포, 기술적인 도전적인 스타운트 레이싱 게임입니다. 수백 개의 다양한 레벨로 이루어진 이 레이스에서, 각 새로운 트랙은 독특한 디자인으로 완전히 다른 흥분을 불러일으킵니다. 인공지능 레이서와 대결하거나 2인 모드로 친구와 함께 플레이할 수 있습니다. 끝없는 레이싱 흥분을 지금 시작하세요!",
      "instructions": "플레이어 1\n이동: \"W,A,S;D\" (1인 플레이어 모드에서도 방향키 활성화)\n니트로: \"SHIFT\"\n재생성: \"R\"\n카메라: \"C\"\n\n플레이어 2\n이동: \"방향키\"\n니트로: \"N\"\n재생성: \"U\"\n카메라: \"L\"",
      "genres": [
        "캐주얼",
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "1플레이어",
        "2플레이어",
        "자동차",
        "장애물",
        "로빅스"
      ]
    },
    "fr": {
      "title": "Course de cascades de voitures épique Obby",
      "description": "Epic Car Stunt Race Obby est un jeu de course acrobatique rapide et défiant. Dans ces courses avec des centaines de niveaux différents, chaque nouvelle piste crée une excitement complètement différente avec son design spécial. Vous pouvez jouer à Epic Car Stunt Race Obby contre des pilotes IA ou avec votre ami en mode multijoueur 2 joueurs. Commencez l'excitation infinie des courses maintenant !",
      "instructions": "Joueur 1\nMouvement : \"W,A,S;D\" (Les flèches directionnelles sont également actives en mode 1 joueur.)\nNitro : \"Maj\"\nRenaissance : \"R\"\nCaméra : \"C\"\n\nJoueur 2\nMouvement : \"FLÈCHES DIRECTIONNELLES\"\nNitro : \"N\"\nRenaissance : \"U\"\nCaméra : \"L\"",
      "genres": [
        "Casual",
        "Course et Conduite"
      ],
      "tags": [
        "1 joueur",
        "2 joueurs",
        "voiture",
        "obstacle",
        "Roblox"
      ]
    }
  }
};
